import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getToolByPath, trackToolEvent } from "@/lib/toolAnalytics";

/**
 * Registra automaticamente:
 * - "view": uma vez por ferramenta a cada carregamento de rota
 * - "use": primeira interação real (clique em botão dentro do conteúdo da ferramenta)
 */
export const useToolAnalytics = () => {
  const location = useLocation();
  const usedRef = useRef(false);

  useEffect(() => {
    const tool = getToolByPath(location.pathname);
    if (!tool) return;

    usedRef.current = false;
    trackToolEvent(tool, "view");

    const onClick = (event: MouseEvent) => {
      if (usedRef.current) return;
      const target = event.target as HTMLElement | null;
      const actionable = target?.closest("button, [role='button'], input[type='submit']");
      if (!actionable) return;
      if (actionable.closest("header, footer, nav")) return;
      usedRef.current = true;
      trackToolEvent(tool, "use");
    };

    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [location.pathname]);
};
